/* SkyClean Drones – Leistungsseiten (scd-l-*)
   Einblenden, Bühne öffnet sich (Kopf), Ablauf festgehalten und seitwärts,
   Preisbalken, Vorschaubild in der Leistungsliste.
   Ohne Skript ist alles sichtbar und vollständig; das Skript ergänzt nur. */
(function () {
  if (window.__scdL) return;
  window.__scdL = true;
  var doc = document.documentElement;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  doc.classList.add('l3-js');

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(root) {
    /* Einblenden */
    var items = all('[data-l-in], .l3-list__item, .l3-tiers', root);
    if (still || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      items.forEach(function (el) { io.observe(el); });
    }

    /* Ablauf: Linie füllt sich mit dem Scrollen, Punkte gehen an.
       Auf großen Bildschirmen bleibt der Abschnitt stehen und die Schritte
       laufen seitwärts durch (data-l-pin → .is-pinned). */
    all('[data-l-steps]', root).forEach(function (box) {
      var rail = box.querySelector('.l3-steps__rail');
      var track = box.querySelector('.l3-steps');
      var steps = all('.l3-step', box);
      var sec = box.closest('[data-l-pin]');
      if (still) { steps.forEach(function (s) { s.classList.add('is-on'); }); return; }
      var pinned = false, dist = 0;
      var layout = function () {
        var ok = sec && window.innerWidth >= 1000 && window.innerHeight >= 700 && window.innerWidth > window.innerHeight;
        if (ok !== pinned) {
          pinned = ok;
          sec.classList.toggle('is-pinned', ok);
          if (!ok) { sec.style.height = ''; track.style.removeProperty('--tx'); }
        }
        if (pinned) {
          dist = Math.max(0, track.scrollWidth - box.clientWidth + 40);
          sec.style.height = Math.round(window.innerHeight + dist * 1.15 + window.innerHeight * 0.25) + 'px';
        }
      };
      var tick = function () {
        var p;
        if (pinned) {
          var r = sec.getBoundingClientRect();
          var span = sec.offsetHeight - window.innerHeight;
          p = Math.min(1, Math.max(0, -r.top / span));
          /* kurze Ruhe am Anfang und am Ende, damit der erste und letzte Schritt stehen */
          var q = Math.min(1, Math.max(0, (p - 0.08) / 0.84));
          track.style.setProperty('--tx', (-q * dist).toFixed(1) + 'px');
          rail.style.setProperty('--lp', q.toFixed(3));
          steps.forEach(function (s, i) { s.classList.toggle('is-on', q >= i / Math.max(1, steps.length - 1) - 0.06); });
          return;
        }
        var b = box.getBoundingClientRect();
        var vh = window.innerHeight;
        p = Math.min(1, Math.max(0, (vh * 0.85 - b.top) / (b.height + vh * 0.35)));
        rail.style.setProperty('--lp', p.toFixed(3));
        steps.forEach(function (s, i) { s.classList.toggle('is-on', p >= i / steps.length + 0.02); });
      };
      layout();
      onResize(layout);
      onScroll(tick);
    });

    /* Kopf: Bühne bleibt stehen und öffnet sich auf volle Breite */
    all('[data-l-open]', root).forEach(function (room) {
      var stage = room.querySelector('.l3-hero__stage');
      if (still || !stage) return;
      var live = false;
      var layout = function () {
        var ok = window.innerWidth >= 760 && window.innerHeight >= 560;
        if (ok !== live) { live = ok; room.classList.toggle('is-live', ok); if (!ok) stage.style.removeProperty('--p'); }
      };
      layout();
      onResize(layout);
      onScroll(function () {
        if (!live) return;
        var r = room.getBoundingClientRect();
        var vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        /* beginnt kurz bevor die Bühne oben ankommt, fertig nach drei Vierteln der Haltezeit */
        var span = room.offsetHeight - vh;
        var p = Math.min(1, Math.max(0, (vh * 0.35 - r.top) / (vh * 0.35 + span * 0.75)));
        var e = p * p * (3 - 2 * p);
        stage.style.setProperty('--p', e.toFixed(4));
      });
    });

    /* Video auf der Bühne: bei reduzierter Bewegung anhalten */
    if (still) all('[data-l-video]', root).forEach(function (v) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} });

    /* Leistungsliste: Bild folgt dem Zeiger (nur Maus, nur breit) */
    all('[data-l-index]', root).forEach(function (list) {
      if (still || !window.matchMedia('(hover: hover) and (min-width: 1000px)').matches) return;
      var peek = list.querySelector('.l3-peek');
      if (!peek) return;
      var imgs = all('img', peek);
      var x = 0, y = 0, tx = 0, ty = 0, raf = 0;
      var move = function () {
        x += (tx - x) * 0.18; y += (ty - y) * 0.18;
        peek.style.setProperty('--px', x.toFixed(1) + 'px');
        peek.style.setProperty('--py', y.toFixed(1) + 'px');
        raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.5 ? requestAnimationFrame(move) : 0;
      };
      all('.l3-index__row', list).forEach(function (row, i) {
        row.addEventListener('mouseenter', function () {
          imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); });
          peek.classList.add('is-on');
        });
        row.addEventListener('mouseleave', function () { peek.classList.remove('is-on'); });
      });
      list.addEventListener('mousemove', function (e) {
        tx = e.clientX + 28; ty = e.clientY - 120;
        if (tx + 360 > window.innerWidth) tx = e.clientX - 368;
        if (!raf) raf = requestAnimationFrame(move);
      });
    });
  }

  var rfns = [];
  function onResize(fn) {
    rfns.push(fn);
    if (rfns.length === 1) {
      var t = 0;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { rfns.forEach(function (f) { f(); }); fns.forEach(function (f) { f(); }); }, 120); });
    }
  }

  var fns = [], queued = false;
  function onScroll(fn) {
    fns.push(fn); fn();
    if (fns.length === 1) {
      var run = function () { queued = false; fns.forEach(function (f) { f(); }); };
      var q = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
      window.addEventListener('scroll', q, { passive: true });
      window.addEventListener('resize', q);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme-Editor: neu eingefügte Abschnitte ebenfalls starten */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
